module.exports = __webpack_public_path__ + "img/inspiration_collections.65ad079.webp";